<!--
 * @Descripttion:
 * @version:
 * @Author: renqiang_hu
 * @Date: 2021-05-11 15:49:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-11 15:49:54
 * @FilePath: \heshan_web\src\components\testall.vue
-->
<template>

</template>
<script>
import { sendSock, initWebSocket, websocketclose } from '@/util/socket.js';
export default {
  data() {
    return {

    }
  },
  mounted() {
    // this.getsocket()
  },
  methods: {
    getsocket() {



      initWebSocket(`ws://121.40.169.186:5001/ws?type=4$topic=`, 0)
      sendSock('', 0, (res) => {
        console.log(res)

      })
    },
  }
}
</script>
